import {
    httpStoreProjectMedicalDevices,
    HttpStoreProjectMedicalDevicesOptions
} from '@/features/projects/http/projects.http'
import {QUERY_KEYS, queryClient} from '@/queryClient'
import {useMutation, UseMutationOptions} from '@tanstack/react-query'

export const useStoreProjectMedicalDevices = ({
    urlParams,
    options
}: {
    urlParams: HttpStoreProjectMedicalDevicesOptions['urlParams']
    options?: UseMutationOptions<unknown, unknown, HttpStoreProjectMedicalDevicesOptions['payload']>
}) =>
    useMutation({
        ...options,
        mutationFn: payload => httpStoreProjectMedicalDevices({urlParams, payload}),
        // Refetch the project so the header progressStatus (backend-computed) reflects this change.
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.PROJECT, urlParams.projectId]})
            options?.onSuccess?.(data, variables, context)
        }
    })
